import { createFileRoute } from '@tanstack/react-router';
import AssignmentRulesPage from '@/pages/setup/assignment-rules/AssignmentRulesPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface AssignmentRulesSearch {
  id?: string;
  mode?: 'create' | 'create-catch-all';
}

export const Route = createFileRoute('/_authenticated/setup/assignment-rules')({
  beforeLoad: () => requireSetupPageAccess('/setup/assignment-rules'),
  validateSearch: (raw: Record<string, unknown>): AssignmentRulesSearch => ({
    id: typeof raw.id === 'string' ? raw.id : undefined,
    mode: raw.mode === 'create' || raw.mode === 'create-catch-all' ? raw.mode : undefined,
  }),
  component: AssignmentRulesPage,
});
